import { FunctionComponent } from 'react'

import { LIVE_EVENT_DATA_SPORT_TYPES } from '@utils/formatters/common'
import useIsInCollapsibleScoreboard from '@hooks/useIsInCollapsibleScoreboard'
import useScoreboard from '@hooks/useScoreboard'
import ScoreboardAggregate from '@components/Scoreboard/ScoreboardAggregate'

import ScoreboardMatchAdditionalScore from './ScoreboardMatchAdditionalScore'
import ScoreboardMatchScore from './ScoreboardMatchScore'
import ScoreboardOpponentSeparator from './ScoreboardOpponentSeparator'

const ScoreboardMatchResultSoccer: FunctionComponent = () => {
  const { formattedData } =
    useScoreboard<typeof LIVE_EVENT_DATA_SPORT_TYPES.SOCCER>()

  const {
    aggregateIndicator,
    scoreExplanation,
    isScheduled,
    hasPenalties,
    teams,
  } = formattedData

  const isInCollapsibleScoreboard = useIsInCollapsibleScoreboard()
  const scoreKey = hasPenalties ? 'scorePenalties' : 'scoreBeforePenalties'
  const awayScore = teams[1][scoreKey]
  const homeScore = teams[0][scoreKey]
  const shouldShowScoreboardAggregate =
    !!aggregateIndicator && !isInCollapsibleScoreboard
  const shouldShowScoreboardOpponentSeparator =
    isScheduled && !isInCollapsibleScoreboard

  return (
    <>
      {!isScheduled && (
        <>
          <ScoreboardMatchScore
            awayScore={awayScore}
            homeScore={homeScore}
            explanation={scoreExplanation}
          />
          {hasPenalties && !isInCollapsibleScoreboard && (
            <ScoreboardMatchAdditionalScore />
          )}
        </>
      )}
      {shouldShowScoreboardAggregate && <ScoreboardAggregate />}
      {shouldShowScoreboardOpponentSeparator && <ScoreboardOpponentSeparator />}
    </>
  )
}

export default ScoreboardMatchResultSoccer
